import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const LEVEL = { superadmin: 100, tenant_owner: 80, admin: 60, supervisor: 50, validator: 40, analyst: 30, seller: 20 };

export default function ProtectedRoute({ children, min = "seller" }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="grid min-h-screen place-items-center"><Loader2 className="h-8 w-8 animate-spin text-brand" /></div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if ((LEVEL[user.role] || 0) < LEVEL[min]) {
    return (
      <div className="grid min-h-screen place-items-center bg-[#FAFAFB] px-6 text-center">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Acceso denegado</h1>
          <p className="mt-2 text-slate-500">Tu rol ({user.role}) no tiene permiso para esta sección.</p>
        </div>
      </div>
    );
  }
  return children;
}
